import script from "./FolderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FolderView.vue?vue&type=script&setup=true&lang=ts"

import "./FolderView.vue?vue&type=style&index=0&id=8b394600&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b394600"]])

export default __exports__